// src/components/GaiaProductsSection.js
import React from 'react';
// Import Swiper React components
import { Swiper, SwiperSlide } from 'swiper/react';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/navigation';
// import 'swiper/css/pagination'; // Décommentez si besoin
import 'swiper/css/autoplay';

// import required modules
import { Navigation, A11y, Autoplay } from 'swiper/modules';

// MODIFIÉ : Importe ProductCard2
import ProductCard2 from './ProductCard2'; // Assurez-vous que ce composant existe
import './GaiaProductsSection.css';   // Garde ses propres styles de section

const gaiaProductsData = [
  // --- COLORATION VÉGÉTALE (COULeurs Gaïa) ---
  {
    id: 'gaiaColoration',
    name: "Coloration Végétale Couleurs Gaïa",
    description: "Des couleurs uniques, lumineuses et personnalisées, 100% végétales. Une alternative saine sans ammoniaque ni produits de synthèse.",
    imageSrc: "/images/couleur.webp" // À remplacer par une image représentative de la coloration végétale Gaïa si vous en avez une plus spécifique
  },
  // --- SOINS CAPILLAIRES & COIFFANTS NATURELS ---
  {
    id: 'instantPresent',
    name: "Instant Présent - Huile de soin bio",
    description: "Nourrit et répare les cheveux secs et abîmés. Utilisée en bain d'huile, elle renforce la fibre capillaire et favorise la pousse.",
    imageSrc: "/images/instant.webp" // Image à ajouter dans public/images
  },
  {
    id: 'veloursMask',
    name: "Velours - Masque nutritif bio",
    description: "Répare, lisse et nourrit en profondeur. Sa formule crème unique apporte douceur et brillance aux cheveux.",
    imageSrc: "/images/velours.webp" // Image à ajouter dans public/images
  },
  {
    id: 'coconShampoo',
    name: "Cocon - Shampoing réparateur bio",
    description: "Formulé sans sulfate, idéal pour cheveux secs, abîmés, cassants et colorés. Purifie et assainit le cuir chevelu.",
    imageSrc: "/images/cocon.webp" // Image à ajouter dans public/images
  },
  {
    id: 'plumeShampoo',
    name: "Plume - Shampoing doux bio",
    description: "Sans sulfate, adapté pour les cheveux normaux ou colorés en végétal. Pour des cheveux souples et brillants.",
    imageSrc: "/images/plume.webp" // Image à ajouter dans public/images
  },
  {
    id: 'pureteShampoo',
    name: "Pureté - Shampoing équilibrant bio",
    description: "Conseillé pour cheveux gras et cuirs chevelus à problèmes (pellicules, démangeaisons). Purifie et assainit.",
    imageSrc: "/images/purete.webp" // Image à ajouter dans public/images
  },
  {
    id: 'cotonBaume',
    name: "Coton - Baume démêlant bio",
    description: "Plus qu'un après-shampoing, il protège, gaine et lisse le cheveu. Apporte soin, brillance et douceur.",
    imageSrc: "/images/coton.webp" // Image à ajouter dans public/images
  },
  {
    id: 'embrunsSpray',
    name: "Embruns - Spray salin bio",
    description: "Redessine les ondulations naturelles pour un effet wavy 'sortie de plage'. Apporte volume en quelques vaporisations.",
    imageSrc: "/images/embruns.webp" // Image à ajouter dans public/images
  },
  {
    id: 'volupteMousse',
    name: "Volupté - Mousse coiffante bio",
    description: "Gaine et donne du volume aux cheveux sans les agresser. Offre un maintien durable aux coiffures sur cheveux humides.",
    imageSrc: "/images/volupte.webp" // Image à ajouter dans public/images
  },
  {
    id: 'esquissePate',
    name: "Esquisse - Pâte sculptante bio",
    description: "Texturise et sculpte les coiffures. Allie douceur d'une pommade et fixant d'un gel, sans film gras.",
    imageSrc: "/images/esquisse.webp" // Image à ajouter dans public/images
  },
  {
    id: 'tziganePoudre',
    name: "Tzigane - Poudre texturisante 100% naturelle",
    description: "Apporte du volume aux cheveux pour un fini mat et naturel. Crée un effet 'coiffé-décoiffé' longue durée sur cheveux courts.",
    imageSrc: "/images/tzigane.webp" // Image à ajouter dans public/images
  }
];

function GaiaProductsSection() {
  return (
    <section id="gaia-products" className="gaia-products-section">
      <div className="container">
        <h2 className="section-title gaia-section-title">L'Art de la Couleur Végétale avec Gaïa</h2>
        <p className="section-subtitle gaia-intro">
          Plongez dans l'univers des colorations 100% végétales et des soins capillaires biologiques Gaïa.
          Une approche douce et respectueuse pour des cheveux naturellement beaux et éclatants de santé.
        </p>

        {/* MODIFICATION: Remplacement du div .gaia-products-scroller par Swiper */}
        <Swiper
          modules={[Navigation, A11y, Autoplay]}
          spaceBetween={20} // Espace entre les slides
          slidesPerView={1} // Affichage par défaut pour mobile
          navigation
          loop={true}
          autoplay={{
            delay: 5000, // Un délai légèrement différent pour varier les carrousels
            disableOnInteraction: false,
            pauseOnMouseEnter: true,
          }}
          grabCursor={true}
          breakpoints={{
            // Pour tablettes (2 produits visibles)
            640: { // Se déclenche un peu avant 768px
              slidesPerView: 2,
              spaceBetween: 25,
            },
            // Pour ordinateurs portables / petits écrans de bureau (3 produits visibles)
            1024: {
              slidesPerView: 3,
              spaceBetween: 30,
            },
            // Pour écrans de bureau plus larges (4 produits visibles)
            1200: { 
              slidesPerView: 4, // Si ProductCard2 a une largeur d'environ 250-280px
              spaceBetween: 30,
            }
          }}
          className="gaia-swiper-container" // Nouvelle classe pour le style spécifique Swiper
        >
          {gaiaProductsData.map(product => (
            <SwiperSlide key={product.id}>
              {/* Utilise ProductCard2 */}
              <ProductCard2
                name={product.name}
                description={product.description}
                imageSrc={product.imageSrc}
              />
            </SwiperSlide>
          ))}
        </Swiper>

        <p className="gaia-availability-note">
          Découvrez la gamme Gaïa et bénéficiez de conseils experts pour votre coloration végétale au Studio Ambre.
        </p>
      </div>
    </section>
  );
}

export default GaiaProductsSection;